import { Elm } from "~/javascript/Page/Agents/New.elm";
import Page from "~/javascript/Page.js";

Page.program(Elm.Page.Agents.New, "agents-new-container");
